<script setup>
import NavItems from "@/Components/Navigation/NavItems.vue";
</script>

<template>
    <nav class="hidden xl:block font-semibold text-sm">
        <ul class="flex gap-1.5 items-center h-[68px]">
            <NavItems :show-header-actions="false" />
        </ul>
    </nav>
</template>

<style scoped></style>
